export const getWidgetFriendsStyle = (theme) => ({
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    maxWidth: '30rem',
    marginBottom: '.75rem',
    textAlign: 'center',
});